import moment from "moment"

// Date du brevet 2026 : vendredi 26 juin.
// À configurer côté admin/back en V1.1.
export const BREVET_2026_DATE = "2026-06-26"

export const daysUntilBrevet = (referenceDate = null) => {
    const now = referenceDate ? moment(referenceDate) : moment()
    const brevet = moment(BREVET_2026_DATE)
    const diff = brevet.diff(now, "days")
    return Math.max(diff, 0)
}
